import { extractDate } from "../../../../utils/dateUtils";
import type { NewVisitValues, VisitDisplay } from "../types";
import { createCitationDraftRow } from "./visitCitations";

export const getTopmostVisibleVisit = (
  container: HTMLElement | null,
  visits: VisitDisplay[]
): VisitDisplay | null => {
  if (!container) return null;
  const containerTop = container.getBoundingClientRect().top;
  const topmostEl = Array.from(container.querySelectorAll<HTMLElement>("[data-visit-id]")).find(
    (el) => el.getBoundingClientRect().top - containerTop >= 0
  );
  const id = topmostEl?.dataset.visitId ?? null;
  return id ? (visits.find((v) => v.visit_id === id) ?? null) : null;
};

export const buildNewVisitPrefill = (visit: VisitDisplay | null): NewVisitValues => ({
  visit_date: extractDate(visit?.visit_date) ?? "",
  visit_type_id: visit?.visit_type_id ?? "",
  provider_name: visit?.provider_name ?? "",
  facility_name: visit?.facility_name ?? "",
  visit_subtype: visit?.visit_subtype ?? "",
  citations: [createCitationDraftRow(visit?.citations[0]?.file_id)],
});
